import type { ReactElement, SVGProps } from 'react';
import {
  EmailIcon,
  FileIcon,
  HtmlIcon,
  ImageIcon,
  PdfFileIcon,
  SpreadsheetIcon,
  WordFileIcon,
} from '@repo/atomic-components';

type IconComponent = (props: SVGProps<SVGSVGElement>) => ReactElement;

// PDF and Word use the mini icons; the lettered ones are unreadable at chip size.
const ICON_BY_EXTENSION: Record<string, IconComponent> = {
  csv: SpreadsheetIcon,
  doc: WordFileIcon,
  docx: WordFileIcon,
  eml: EmailIcon,
  htm: HtmlIcon,
  html: HtmlIcon,
  jpeg: ImageIcon,
  jpg: ImageIcon,
  md: FileIcon,
  msg: EmailIcon,
  pdf: PdfFileIcon,
  png: ImageIcon,
  rtf: WordFileIcon,
  tif: ImageIcon,
  tiff: ImageIcon,
  txt: FileIcon,
  xls: SpreadsheetIcon,
  xlsx: SpreadsheetIcon,
};

interface FileTypeIconProps extends SVGProps<SVGSVGElement> {
  fileName?: string | null;
  /**
   * Explicit extension (e.g. `documentFormat`), used over the one from `fileName` — Proclaim names often have none.
   */
  extension?: string | null;
}

/**
 * File-type icon by extension, with a generic fallback. All icons share viewBox height 195, so one
 * `height` sizes them consistently.
 */
export const FileTypeIcon = ({ fileName, extension, ...svgProps }: FileTypeIconProps) => {
  const resolvedExtension = (extension?.trim() || fileName?.split('.').pop() || '').toLowerCase();
  const IconComponent = ICON_BY_EXTENSION[resolvedExtension] ?? FileIcon;
  return <IconComponent {...svgProps} />;
};
